import Header from './Header';
export default Header;



// WEBPACK FOOTER //
// ./src/layout/App/components/AuthContainer/components/RelayRootContainer/components/IntlContainer/components/RoutesContainer/components/Header/index.js